import React from 'react';
import styles from './styles/XPaletteItem.module.scss';
import { XComponent } from './components/commons/XComponent';
import { IComponentState } from './components/commons/IComponentState';
import { IComponentProps } from './components/commons/IComponentProps';

export interface IPaletteItemProps extends IComponentProps {
    text? : string | undefined;
    color : string;
}

export interface IPaletteItemState extends IComponentState {
}

export class XPaletteItem extends XComponent<HTMLDivElement, IPaletteItemProps, IPaletteItemState> {
    public constructor(props: IPaletteItemProps) {
        super(props);
    }
    
    componentDidMount(): void{
        super.componentDidMount();
        const {current} = this.reference;
        if(current) {
            const style: string
                = current.getAttribute('style')
                + '--background-color:' + this.props.color + ';';
            current.setAttribute('style', style);
        }
    }
    componentWillUnmount(): void{}
    
    render(): React.ReactNode {
        return (
            <div ref={this.reference} className={styles.XPaletteItem}>{this.props.text}</div>
        );
    }
}
